/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ToggleInputs */

const en_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector`)
};

const ar_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفاحص`)
};

const bn_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইন্সপেক্টর`)
};

const de_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor`)
};

const es_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector`)
};

const fr_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur`)
};

const pt_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor`)
};

const zh_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查器`)
};

const tr_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetçi`)
};

const ru_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инспектор`)
};

const pl_image_inspector_toggle = /** @type {(inputs: Image_Inspector_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor`)
};

/**
* | output |
* | --- |
* | "Inspector" |
*
* @param {Image_Inspector_ToggleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_toggle = /** @type {((inputs?: Image_Inspector_ToggleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ToggleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_toggle(inputs)
	if (locale === "bn") return bn_image_inspector_toggle(inputs)
	if (locale === "de") return de_image_inspector_toggle(inputs)
	if (locale === "es") return es_image_inspector_toggle(inputs)
	if (locale === "fr") return fr_image_inspector_toggle(inputs)
	if (locale === "pt") return pt_image_inspector_toggle(inputs)
	if (locale === "zh") return zh_image_inspector_toggle(inputs)
	if (locale === "tr") return tr_image_inspector_toggle(inputs)
	if (locale === "ru") return ru_image_inspector_toggle(inputs)
	if (locale === "pl") return pl_image_inspector_toggle(inputs)
	return en_image_inspector_toggle(inputs)
});